import { useMonitor } from "@suse-o11y/signal";
import React from "react";

import { HighlightTimestampCursor, useTimestampCursorState } from "../../TimestampCursor";

import { TimelineMarker } from "./TimelineMarker";

export const TimelineMarkers: React.FC = () => {
	const monitor = useMonitor();
	const timestampCursorState = useTimestampCursorState();
	const isTimestampCursorHotkeyPressed = timestampCursorState.isHotkeyPressed(monitor);

	return (
		<div className={isTimestampCursorHotkeyPressed ? "pointer-events-auto" : "pointer-events-none"}>
			{timestampCursorState.getAllMarkers(monitor).map(({ timestamp, isHighlighted }) => (
				<TimelineMarker key={timestamp} theme={isHighlighted ? "red" : "purple"} timestamp={timestamp}>
					{/* the negative margin creates an invisible clickable marker's area */}
					<HighlightTimestampCursor className="absolute inset-0 m-[-3px]" timestamp={timestamp} />
				</TimelineMarker>
			))}
		</div>
	);
};
